export interface InteractionTrackingState {
  id: string;
  type: string
  status: InteractionStatus2
  progress: number
  state: unknown
}

export type InteractionStatus2 = 'not-attempted' | 'incomplete' | 'completed'

export function defaultInteractionTrackingState(id: string): InteractionTrackingState {
  return {
    id,
    type: '',
    status: 'not-attempted',
    progress: 0,
    state: undefined
  };
}
